import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import React, { useCallback } from 'react';

interface IModalProps {
  onClose: () => void;
  open: boolean;
}

const ModalInfo = ({ open, onClose }: IModalProps) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  return (
    <Dialog maxWidth={'md'} onClose={handleClose} aria-labelledby='advanced-filter' open={open}>
      <DialogTitle id='dialog-title'>RELATÓRIO DE VENDAS</DialogTitle>
      <DialogContent dividers>
        <p>Observações:</p>
        <p>
          Faturas com mais de um item terão seus detalhes exibidos em linhas diferentes com o mesmo número de fatura. O valor da venda, porém, será
          mostrado apenas na linha do item principal, aparecendo zerado nas demais linhas, para facilitar assim o seu controle de vendas e ganhos. ;)
        </p>
        <p>Em caso de dúvidas, entre em contato com o nosso Canal de Atendimento em suporte@eduzz.com.</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalInfo;
